export class ConsultaRequest {
  get cpfCnpjCliente() {
    return this._cpfCnpjCliente;
  }

  set cpfCnpjCliente(value) {
    this._cpfCnpjCliente = value;
  }

  get dataNascimento() {
    return this._dataNascimento;
  }

  set dataNascimento(value) {
    this._dataNascimento = value;
  }

  get numeroContrato() {
    return this._numeroContrato;
  }

  set numeroContrato(value) {
    this._numeroContrato = value;
  }

  get telefone() {
    return this._telefone;
  }

  set telefone(value) {
    this._telefone = value;
  }

  get email() {
    return this._email;
  }

  set email(value) {
    this._email = value;
  }

  constructor (cpfCnpjCliente, dataNascimento, numeroContrato, telefone, email) {
    this._cpfCnpjCliente = cpfCnpjCliente
    this._dataNascimento = dataNascimento
    this._numeroContrato = numeroContrato
    this._telefone = telefone
    this._email = email
  }
}
